import { useTheme } from '@mui/material/styles';
import grey from "@mui/material/colors/grey";

export const DistrictCardStyles = () => {
  const theme = useTheme();

  return {
    background: theme.palette.primary.main,
    height: "100%",
    padding: "7px",
    "& .label": {
      color: theme.palette.primary.light,
      display: "inline-block",
      fontWeight: "bold",
      marginBottom: "0",
    },
    "& .DistrictCard__wrapper": {
      padding: "6px",
    },
    "& .DistrictCard__header": {
      color: "#fff",
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "6px",
    },
    "& .DistrictCard__header .label": {
      marginBottom: "0px",
      marginRight: "6px",
    },
    "& .DistrictCard__header .DistrictCard__info": {
      display: "block",
    },
    "& .DistrictCard__data": {
      display: {
        md: "flex",
      },
      margin: "10px 0",
    },
    "& .DistrictCard__data .label": {
      color: theme.palette.primary.dark,
      minWidth: "400px",
    },
    "& h2": {
      color: "#fff",
      fontSize: "26px",
      fontWeight: "bold",
      margin: "0",
      padding: "0 10px 4px",
    },
    "& .DistrictCard__address": {
      display: "flex",
      marginBottom: "4px",
    },
    "& .DistrictCard__icon": {
      borderRight: `1px solid ${theme.palette.primary.light}`,
      marginRight: "10px",
      textAlign: "center",
      width: "40px",
    },
    "& .DistrictCard__icon svg": {
      color: theme.palette.primary.light,
    },
    "& .DistrictCard__info": {
      display: "inline-block",
      margin: "0 8px",
    },
    "& .DistrictCard__info a": {
      color: '#fff',
    },
    "& .DistrictCard__revenue": {
      display: "inline-block",
      margin: "0 8px",
    },
    "& .DistrictCard__revenue label": {
      color: "#000",
    },
    "& .DistrictCard__image": {
      background: "#fff",
      borderRadius: "50%",
      display: {
        xs: "none",
        md: "block",
      },
      height: "120px",
      overflow: "hidden",
      position: "absolute",
      right: "20px",
      top: "14px",
      width: "120px",
    },
    "& .DistrictCard__image img": {
      width: "100%",
      height: "auto",
    },
    "& .DistrictCard__content": {
      background: "white",
      padding: "17px",
      overflow: "hidden",
      fontSize: {
        xs: "small",
        sm: "medium",
        md: "initial"
      },
      minHeight: {
        sm: "100px",
        md: "280px"
      }
    },
    "& .DistrictCard__actions": {
      position: "relative",
      width: {
        md: "100%",
      }
    },
    "& .DistrictCard__print": {
      color: "white",
    },
    "& .DistrictCard__print:hover": {
      color: theme.palette.primary.light,
    },
    "& .DistrictCard__print svg": {
      marginLeft: "4px",
    },
    "& .TableContent": {
      borderBottom:  `1px dotted ${grey[300]}`,
    },
    "& .TableContent table th": {
      padding: "6px 0",
      borderBottom: "none",
      color: theme.palette.primary.dark,
      fontWeight: "bold",
      marginBottom: "0",
      fontSize: "initial"
    },
    "& .TableContent table td": {
      padding: "10px 5px 10px 0",
      borderBottom: "none",
      fontSize: "initial"
    },
    "& .FlipTableStyles table th": {
      fontWeight: "bold",
    },
    "& .FlipTableStyles table thead th": {
      border: "0",
      fontWeight: "bold",
      padding: "0 4px",
    },
    "& .FlipTableStyles table thead span": {
      background: theme.palette.primary.main,
      color: "#fff",
      display: "block",
      padding: "4px 8px",
    },
    "& .FlipTableStyles table tbody td": {
      textAlign: "center",
    },
    "& .FlipButton": {
      color: "white !important",
      backgroundColor: `${theme.palette.primary.light} !important`,
      position: "absolute",
      right: "-10px",
      top: "-62px",
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      padding: "36px !important",
    },
    "& .row-divider": {
      borderTop: "2px dotted #c6c6c6",
    },
    "& .TableContent table .extra-data.row-divider > *": {
      paddingTop: "14px"
    },
    "& .TableContent table .extra-data > *": {
      padding: "5px 0"
    }
  }
}
